import styled from 'styled-components'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'

const Placeholder = () => {
  return (
    <Container>
      <TextWidth>
        <Line style={{ width: '100%' }} />
        <Line style={{ width: '60%' }} />
      </TextWidth>
    </Container>
  )
}

const Container = styled.div`
  padding: 3rem 0;
  width: 100%;
  display: block;
  background-color: ${({ theme }) => theme.colorGreyLight};
`

const Line = styled.div`
  margin-bottom: 0.5rem;
  opacity: 0.5;
  height: 20px;
  border-radius: 4px;
  overflow: hidden;
  animation: placeholderShimmer 2s linear;
  animation-iteration-count: infinite;
  background-image: linear-gradient(
    to right,
    rgba(${({ theme }) => theme.colorMode === 'light' ? '0, 0, 0' : '255, 255, 255'}, 0.08) 0,
    rgba(${({ theme }) => theme.colorMode === 'light' ? '0, 0, 0' : '255, 255, 255'}, 0.15) 15%,
    rgba(${({ theme }) => theme.colorMode === 'light' ? '0, 0, 0' : '255, 255, 255'}, 0.08) 30%
  );
  background-size: 1200px 100%;

  @keyframes placeholderShimmer {
    0% {
      background-position: -1200px 0;
    }
    100% {
      background-position: 1200px 0;
    }
  }
`

export default Placeholder
